// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AgHjYVBAtOCAAf {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
}
.yBwUopYPBwcULL {
  width: 20px;
  height: 20px;
}
._ly3opemkGXcwG {
  width: 24px;
  height: 24px;
}
.NRl3gC65VDZ4hv {
  width: 32px;
  height: 32px;
}
.UdDrGFeC5zRX9_ {
  width: 40px;
  height: 40px;
}
.NqqfrNKdDH7DRW {
  width: 44px;
  height: 44px;
}
.tr09fEc5EpbMtH {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.WQZ8ApvjBNC1eI {
  filter: brightness(60%) sepia(1) hue-rotate(180deg) saturate(100.5%) brightness(125%) contrast(1.2);
  background-color: var(--ds-background-neutral-bold, #42526e);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoContainer": `AgHjYVBAtOCAAf`,
	"xxsmallLogoContainer": `yBwUopYPBwcULL`,
	"xsmallLogoContainer": `_ly3opemkGXcwG`,
	"smallLogoContainer": `NRl3gC65VDZ4hv`,
	"mediumLogoContainer": `UdDrGFeC5zRX9_`,
	"largeLogoContainer": `NqqfrNKdDH7DRW`,
	"workspaceLogo": `tr09fEc5EpbMtH`,
	"desaturateLogo": `WQZ8ApvjBNC1eI`
};
export default ___CSS_LOADER_EXPORT___;
